export const DEFAULT_PROJECT_COLOR_CSS_VAR = 'hsl(var(--muted-foreground))';
export const DEFAULT_PROJECT_COLOR_HEX = '#727279';
